import {
  IsBoolean,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { NamedEntityDto } from '../clinical-details';
import { DispositionDto } from './disposition.dto';

export class ClinicalManagementActionDto extends NamedEntityDto {
  @IsOptional()
  @IsBoolean()
  requiresUserInput?: boolean;

  @IsOptional()
  @ValidateNested()
  disposition?: DispositionDto;

  @IsOptional()
  @ValidateNested()
  parentAction?: ClinicalManagementActionDto;

  @IsOptional()
  @IsString()
  subActionsCaption?: string;

  @IsOptional()
  @IsString()
  subActionsCaption_da?: string;

  @IsOptional()
  @IsString()
  subActionsCaption_de?: string;

  @IsBoolean()
  caseUrgencyEnabled: boolean;
}

export class ClinicalManagementActionQueryDto {
  @IsOptional()
  @IsUUID()
  conditionTypeId?: string;
}
